import { render } from "./EtiquetaPedidoAguardandoAprovacao.vue?vue&type=template&id=6e6f75e0&scoped=true"
import script from "./EtiquetaPedidoAguardandoAprovacao.vue?vue&type=script&lang=js"
export * from "./EtiquetaPedidoAguardandoAprovacao.vue?vue&type=script&lang=js"

import "./EtiquetaPedidoAguardandoAprovacao.vue?vue&type=style&index=0&id=6e6f75e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6f75e0"]])

export default __exports__